'use strict';

/** @type {import('./maxSafeInteger')} */
// eslint-disable-next-line no-extra-parens
module.exports = /** @type {import('./maxSafeInteger')} */ (Number.MAX_SAFE_INTEGER) || 9007199254740991; // Math.pow(2, 53) - 1;



/*****************
 ** WEBPACK FOOTER
 ** ./~/math-intrinsics/constants/maxSafeInteger.js
 ** module id = 367
 ** module chunks = 0
 **/